// extracted by mini-css-extract-plugin
export var main = "_2-1";
export var shell = "_2-0";